// Isometric tile dimensions
export const TILE_W = 96;  // pixels at @1x
export const TILE_H = 48;  // pixels at @1x (2:1 dimetric ratio)

// Grid settings
export const GRID_SIZE = 50;  // Default grid size in tiles
export const GRID_COLOR = 0x3a3a3a;
export const GRID_ALPHA = 0.5;

// Viewport settings
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 3.0;
export const DEFAULT_ZOOM = 1.0;

// Asset categories
export const ASSET_CATEGORIES = {
  FLOOR: 'floor',
  MACHINE: 'machine',
  PROP: 'prop',
  DECAL: 'decal',
  WALL: 'wall',
};

// Machine status colors
export const STATUS_COLORS = {
  RUNNING: 0x22c55e,   // green
  IDLE: 0xeab308,      // yellow
  DOWN: 0xef4444,      // red
  OFFLINE: 0x6b7280,   // gray
};

// Selection colors
export const SELECTION_COLOR = 0x3b82f6;
export const HOVER_COLOR = 0x60a5fa;

// Default anchor for entities (bottom center)
export const DEFAULT_ANCHOR = { x: 0.5, y: 1.0 };
